module.exports = __webpack_public_path__ + "img/hr-sand-decal-29.c5e3e39c.png";